import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { UserManagementService } from 'src/app/user-management/user-management.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const userService = inject(UserManagementService);

  return next(req).pipe(
    catchError((error) => {
      return throwError(() => error);
    })
  );
};
